export default __webpack_public_path__ + "static/media/us-flag.7c946ccb.svg";